import posthog from "posthog-js";

const POSTHOG_API_KEY = 'phc_Y1mdGiQkzk4QRydBGlgXbJSLXoCTmcbVVOP5VyLEc70';
const POSTHOG_API_HOST = "https://mississippi.cloaked.app/";

export const getPosthog = () =>
  new Promise((resolve) => {
    if (!window || !POSTHOG_API_KEY) {
      return resolve(null);
    }

    if (window && window.$posthog) {
      return resolve(window.$posthog);
    }

    const posthogOptions = {
      api_host: POSTHOG_API_HOST,
      autocapture: true,
      capture_pageleave: true,
      capture_pageview: true,
      disable_session_recording: true,
      enable_recording_console_log: false,
      mask_all_text: true, // dont leak user data
      mask_all_element_attributes: true, // dont leak user data
      opt_out_capturing_by_default: false,
      persistence: "localStorage",
      loaded: (posthog) => {
        resolve(posthog);
      },
    };

    const $posthog = posthog.init(
      POSTHOG_API_KEY,
      posthogOptions
    );

    window.$posthog = $posthog;
  });

export const posthogCapture = async (eventName, properties) => {
  const posthog = await getPosthog();
  if (posthog) {
    posthog.capture(eventName, {
      ...properties,
      client_platform: "HIBB",
    });
  }
};
